<template>
  <div class="schema-designer-container-9136076486841527">
    <div class="steps-header">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="steps-content">
      <div v-show="current === 0">
        <CsimSchemaAttribute
          @handleSelectForm="handleSelectForm"
          @changeFormDesignTab="changeFormDesignTab"
          ref="CsimSchemaAttribute"
          :model="model"
        />
      </div>
      <div v-show="current === 1">
        <CsimSchemaPeriod
          ref="CsimSchemaPeriod"
          v-on="$listeners"
          :model="model"
        />
      </div>
    </div>
    <div class="steps-action">
      <a-button v-if="current < steps.length - 1" type="primary" @click="next" style="float: right;">
        下一步 ->
      </a-button>
      <a-button v-if="current > 0" style="margin-left: 10px; float: left;" type="primary" @click="prev">
       <- 上一步
      </a-button>
    </div>
  </div>
</template>

<script>
import "./styles/schema-design.less";
import CsimSchemaAttribute from "./module/CsimSchemaAttribute";
import CsimSchemaPeriod from "./module/CsimSchemaPeriod";

export default {
  name: "CsimSchemaDesign",
  components: {
    CsimSchemaPeriod,
    CsimSchemaAttribute,
  },
  data() {
    return {
      loadState: false,
      model: {
        id: "",
        formList:[],
        keywordList:[],
      },
      selectForm: {},
      current: 0,
      steps: [
        {
          title: '方案基础设置',
          content: '方案相关的基本信息，如方案名称、方案类型等',
        },
        {
          title: '方案时间点设置',
          content: '管理周期和周期表单',
        },
      ],
    };
  },
  methods: {
    handleSetSchema(record) {
      console.log(this.current);
      this.model = record;

      let that = this;
      this.$nextTick(() => {
        that.$refs.CsimSchemaAttribute.handleSetSchema(record);
        that.$refs.CsimSchemaPeriod.handleSetSchema(record);
      });
    },
    handleSelectForm(record) {
      this.selectForm = record;
    },
    changeFormDesignTab(type, formInfo) {
      this.$emit("changeFormDesignTab", type, formInfo);
    },
    next() {
      this.current++;
      this.updateWindowsSize();
    },
    prev() {
      this.current--;
      this.updateWindowsSize();
    },
    updateWindowsSize() {
      this.$nextTick(() => {
        if (this.current === 0) {
          this.$refs.CsimSchemaAttribute.updateWidths();
        } else if (this.current === 1) {
          this.$refs.CsimSchemaPeriod.updateWidths();
        }
      });
    }
  },
};
</script>

<style scoped>
.steps-header{
  padding: 16px 50px;
}
.steps-content {
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
/*  background-color: #fafafa; */
  min-height: 200px;
/*  height: 100vh; */
  padding-top: 10px;
}

.steps-action {
  bottom: 0px;
  width: 100%;
  position: fixed;
  z-index: 1000;
  background: #f7f7f7;
  padding: 10px;
  margin-left: -25px;
}
</style>